import {analyticsLogEvent} from '../api'

interface Parameters {
    /** Label of the carousel tab the user switched to (e.g. "Potrebbe piacerti" / "Completa il look"). */
    tabName: string
    /** Master SKU of the current PDP product. */
    sku: string
}

/**
 * @name analyticsEventPdpCarouselSwitch
 *
 * @event
 *
 * @description
 * Tracks the switch between recommendation carousel tabs on the PDP
 * (Einstein "Potrebbe piacerti" ↔ Commerce "Completa il look").
 * Manuale BitBang "GTM Tracciamenti – PDP PWA" v1.0 §3.1.7.
 *
 * dataLayer shape:
 * `{ event: 'custom_event', eventCategory: 'pdp_carousel_switch', eventAction: '[CAROUSEL TAB NAME]', eventLabel: '[SKU]' }`
 *
 * @param {Object} params - Object containing the event parameters.
 * @param {string} params.tabName - Selected carousel tab name, mapped to `eventAction`.
 * @param {string} params.sku - Current product master SKU, mapped to `eventLabel`.
 */
export function analyticsEventPdpCarouselSwitch({tabName, sku}: Parameters) {
    analyticsLogEvent('custom_event', {
        eventCategory: 'pdp_carousel_switch',
        eventAction: tabName,
        eventLabel: sku,
    })
}
